import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../pages/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/nosotros",
    name: "About",
    component: () => import("../pages/About.vue"),
  },
  {
    path: "/contacto",
    name: "Contacto",
    component: () => import("../pages/Contact.vue"),
  },
  {
    path: "/recursos",
    name: "Recursos",
    component: () => import("../pages/Resource.vue"),
  },
  {
    path: "/recursos/:type",
    name: "Resources",
    component: () => import("../pages/Article.vue"),
  },
  {
    path: "/observatorio",
    name: "Observatorio",
    component: () => import("../pages/Observatory.vue"),
  },
  {
    path: "/categoria/:type",
    name: "Categoría",
    component: () => import("../pages/Category.vue"),
  },
  {
    path: "/componentes",
    name: "Componentes",
    component: () => import("../components/Components.vue"),
  },
  {
    path: "/regulacion",
    name: "Regulación",
    component: () => import("../pages/Regulacion.vue"),
  },
  {
    path: "/numeros-percepciones",
    name: "Números y Percepciones",
    component: () => import("../pages/NumerosPercepciones.vue"),
  },
  {
    path: "/numeros-percepciones/:type",
    name: "Numbers and Perceptions",
    component: () => import("../pages/Article.vue"),
  },
  {
    path: "/eventos",
    name: "Eventos",
    component: () => import("../pages/Eventos.vue"),
  },
  {
    path: "/eventos/:type",
    name: "Events",
    component: () => import("../pages/Course.vue"),
  },
  {
    path: "/enlaces",
    name: "Enlaces",
    component: () => import("../pages/Enlaces.vue"),
  },
  {
    path: "/enlaces/:type",
    name: "Links",
    component: () => import("../pages/Article.vue"),
  },
  {
    path: "/observatorio/:type",
    name: "Articulo",
    component: () => import("../pages/Article.vue"),
  },
  {
    path: "/categoria/bibliografia/:type",
    name: "Bibliografia",
    component: () => import("../pages/Bibliography.vue"),
  },
  {
    path: "/categoria/situaciones/:type",
    name: "Situaciones",
    component: () => import("../pages/Situations.vue"),
  },
  {
    path: "/categoria/casos/:type",
    name: "Casos",
    component: () => import("../pages/ArticlesCaseCategory.vue"),
  },
  {
    path: "/categoria/entrevistas",
    name: "Entrevistas",
    component: () => import("../pages/Entrevista.vue"),
  },
  {
    path: "/categoria/guia",
    name: "Guia",
    component: () => import("../pages/Guide.vue"),
  },
  {
    path: "/regulacion/:type",
    name: "Regulation",
    component: () => import("../pages/Article.vue"),
  },
  {
    path: "/prueba",
    name: "prueba",
    component: () => import("../pages/Prueba.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  hash: false,
  routes,
});

export default router;
